var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/** Collect focusable, visible, listening nodes in tab order. */
export function collectFocusable(root) {
    var nodes = [];
    walk(root, nodes);
    nodes.sort(function (a, b) {
        var _a, _b;
        var ta = (_a = a.tabIndex) !== null && _a !== void 0 ? _a : 0;
        var tb = (_b = b.tabIndex) !== null && _b !== void 0 ? _b : 0;
        if (ta !== tb)
            return ta - tb;
        return 0;
    });
    return nodes;
}
function walk(node, out) {
    var e_1, _a;
    if ('children' in node) {
        try {
            for (var _b = __values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                walk(child, out);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    if (node.focusable && node.visible && node.listening) {
        out.push(node);
    }
}
